/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class GetSqlVmNetworkInfoRequest {
  /**
  * The Azure cloud account ID
  */
  'cloudAccountId': string;
  /**
  * The Azure resource group name where the VM is located
  */
  'resourceGroup': string;
  /**
  * The Azure SQL VM name
  */
  'vmName': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "cloudAccountId",
      "baseName": "cloudAccountId",
      "type": "string",
      "format": "tobedefined"
    },
    {
      "name": "resourceGroup",
      "baseName": "resourceGroup",
      "type": "string",
      "format": "tobedefined"
    },
    {
      "name": "vmName",
      "baseName": "vmName",
      "type": "string",
      "format": "tobedefined"
    }  ];

  static getAttributeTypeMap() {
    return GetSqlVmNetworkInfoRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

